import React, { FC } from 'react'

import { IconChevronRight, IconClock2, IconInfo } from '@avantstay/backoffice-vectors'

import { Button } from '../../Button'
import { FlexContainer } from '../../FlexContainer'
import { AIActions } from '../AIElements.types'
import * as S from './AIElements.styles'
import { IconTooltip } from './IconTooltip'
import { RateAIResponse } from './RateAIResponse'

export const ActionsRow: FC<AIActions> = ({
  id,
  aiRatingResponseTooltip,
  createdAtContent,
  initialRating,
  infoContent,
  onChangeRating,
  onOpenDetails,
}) => {
  return (
    <FlexContainer flex="0" alignItems="center" gap={12} noWrap>
      {onChangeRating ? (
        <RateAIResponse
          id={id}
          aiRatingResponseTooltip={aiRatingResponseTooltip}
          initialRating={initialRating}
          onChangeRating={onChangeRating}
        />
      ) : null}
      {infoContent ? <IconTooltip content={infoContent} icon={IconInfo} /> : null}
      {createdAtContent ? <IconTooltip content={createdAtContent} icon={IconClock2} /> : null}

      {onOpenDetails ? (
        <S.ButtonWrapper>
          <Button.RoundedOutline onClick={onOpenDetails}>
            <FlexContainer gap={8} noWrap>
              See Details <IconChevronRight />
            </FlexContainer>
          </Button.RoundedOutline>
        </S.ButtonWrapper>
      ) : null}
    </FlexContainer>
  )
}
